import React from "react";
import './mainTitleComponent.css'
import ButtonLinkComponent from "../buttonLink/buttonLink";

const MainTitleComponent = ({ title, text, buttonText, url, blank, isSmallTitle }) => {
    return (
        <section className="mainTitleComponentSection">
            {title && <h1 className={`title ${isSmallTitle ? 'small-title' : ''}`}>{title}</h1>}
            {text && <p className="mainTextTitle">{text}</p>}
            {buttonText && <ButtonLinkComponent
                translateButton={buttonText}
                url={url}
                blank={blank}
            />}
        </section>
    )
}

export default MainTitleComponent;
